import React from 'react';
import { Helmet } from 'react-helmet';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import ProductCategories from '../components/ProductCategories';
import FeaturedProducts from '../components/FeaturedProducts';
import About from '../components/About';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import { PRODUCT_CATEGORIES, SITE_BASE_URL } from '../data/productCategories';

const HomePage = () => {
  const canonicalUrl = SITE_BASE_URL;
  const ogImage = `${SITE_BASE_URL}/trade-zone-logo.png`;

  const categoryItemListSchema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Heavy earth mover spare parts categories',
    numberOfItems: PRODUCT_CATEGORIES.length,
    itemListElement: PRODUCT_CATEGORIES.map((c, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: c.title,
      description: c.shortDescription,
      url: `${SITE_BASE_URL}/category/${c.slug}`,
    })),
  };

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Trade Zone Equipments',
    url: SITE_BASE_URL,
    description:
      'Heavy earth-moving equipment spare parts supplier — excavator, bulldozer, loader, grader, and ADT components with OEM-focused support.',
    publisher: {
      '@type': 'Organization',
      name: 'Trade Zone Equipments',
      url: SITE_BASE_URL,
    },
  };

  return (
    <>
      <Helmet>
        <title>
          Trade Zone Equipments | Heavy Earth Mover Spare Parts — Excavator, Loader & Dozer
        </title>
        <meta
          name="description"
          content="Heavy earth mover spare parts for excavators, bulldozers, wheel loaders, motor graders, and articulated haulers. Engine, hydraulic, undercarriage, GET, filters, cooling, and cab components with expert sourcing from Trade Zone Equipments."
        />
        <meta
          name="keywords"
          content="heavy earth mover spare parts, excavator parts supplier, bulldozer undercarriage, wheel loader hydraulic parts, motor grader transmission, ADT brakes, ground engaging tools, mining equipment spares, Trade Zone Equipments"
        />
        <link rel="canonical" href={canonicalUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta
          property="og:title"
          content="Trade Zone Equipments | Heavy Earth Mover Spare Parts"
        />
        <meta
          property="og:description"
          content="OEM-focused spare parts across engine, hydraulic, drivetrain, undercarriage, GET, filters, cooling, fuel, brakes, attachments, and cab systems for production earth-moving fleets."
        />
        <meta property="og:image" content={ogImage} />
        <meta property="og:locale" content="en_US" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Trade Zone Equipments | Heavy Earth Mover Spare Parts" />
        <meta
          name="twitter:description"
          content="Spare parts for excavators, dozers, loaders, graders, and haul trucks — organized categories and fast quote support."
        />

        <script type="application/ld+json">{JSON.stringify(webSiteSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(categoryItemListSchema)}</script>
      </Helmet>
      
      <div className="min-h-screen bg-[#1a1a1a]">
        <Navigation />
        <Hero />
        <ProductCategories />
        <FeaturedProducts />
        <About />
        <Contact />
        <Footer />
      </div>
    </>
  );
};

export default HomePage;